import { prestataires } from '../../datas/prestataires';

const initialState = {
  user: null,
  isAuthenticated: false,
  clients: [],
  pageActiveClients: 1,
  resultsPerPageClient: 10,
  totalClients: 0,
  prestataires: [],
  pageActivePrestataires: 1,
  resultsPerPagePrestataires: 10,
  totalPrestataire: 0,
  donneursOrdres: [],
  pageActiveDonneursOrdres: 1,
  resultsPerPageDonneursOrdres: 10,
  totalDonneursOrdres: 0,
  admins: [],
  pageActiveAdmins: 1,
  resultsPerPageAdmins: 10,
  totalAdmins: 0



};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case "REGISTER_USER":
      return {
        ...state,
        user: action.payload,
        isAuthenticated: true,
      };
    case "LOGOUT_USER":
      return {
        ...state,
        user: null,
        isAuthenticated: false,
      };
    case "SET_CLIENTS":
      return {
        ...state,
        clients: action.payload.users,
        totalClients: action.payload.total
      }
    case "SET_PRESTATAIRES":
      return {
        ...state,
        prestataires: action.payload.users,
        totalPrestataire: action.payload.total
      }
    case "SET_DONNEURS_ORDRES":
      return {
        ...state,
        donneursOrdres: action.payload.users,
        totalDonneursOrdres: action.payload.total
      }
    case "SET_ADMINS":
      return {
        ...state,
        admins: action.payload.users,
        totalAdmins: action.payload.total
      }
    case "SET_USERS":
      return {
        ...state,
        users: action.payload
      }
    default:
      return state;
  }
};

export default userReducer;
